export default __webpack_public_path__ + "static/media/latest-news-img16.cb80d3e6.jpg";